export default __webpack_public_path__ + "static/media/04.8a8dda73.png";